import React from 'react';
import useImportSteps from "v4/pages/admin/Import/components/ImportSteps/hooks/useImportSteps";
import InlineLoader from "v4/components/ui/InlineLoader/InlineLoader";

export default function ImportSteps() {
    const {
        importSteps,
        currentStep,
        isImportInfosLoading,
    } = useImportSteps();

    return (
        <div className="import-steps">
            {isImportInfosLoading
                ? <InlineLoader/>
                : importSteps[currentStep].component()
            }
        </div>
    )
}
